module.exports = __webpack_public_path__ + "static/media/SDFSA_6-960w.99d9df78.webp";